import script from "./FifthIhramPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FifthIhramPage.vue?vue&type=script&setup=true&lang=js"

import "./FifthIhramPage.vue?vue&type=style&index=0&id=7a77ae6c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a77ae6c"]])

export default __exports__